import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    SHIPMENTPACKAGES_FEATURE_KEY,
    State,
    ShipmentPackagesPartialState,
    shipmentPackagesAdapter,
} from './shipment-packages.reducer';

// Lookup the 'ShipmentPackages' feature state managed by NgRx
export const getShipmentPackagesState = createFeatureSelector<
    ShipmentPackagesPartialState,
    State
>(SHIPMENTPACKAGES_FEATURE_KEY);

const { selectAll, selectEntities } = shipmentPackagesAdapter.getSelectors();

export const getShipmentPackagesLoading = createSelector(
    getShipmentPackagesState,
    (state: State) => state.loading
);

export const getShipmentPackagesError = createSelector(
    getShipmentPackagesState,
    (state: State) => state.error
);

export const getShipmentPackagesPagination = createSelector(
    getShipmentPackagesState,
    (state: State) => state.pagination
);

export const getAllShipmentPackages = createSelector(
    getShipmentPackagesState,
    (state: State) => selectAll(state)
);

export const getShipmentPackagesEntities = createSelector(
    getShipmentPackagesState,
    (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
    getShipmentPackagesState,
    (state: State) => state.selectedId
);

export const getSelected = createSelector(
    getShipmentPackagesEntities,
    getSelectedId,
    (entities, selectedId) => selectedId && entities[selectedId]
);
